import React, { useState, useEffect } from "react";
import { FiSave, FiArrowLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import useAuth from "../useAuth";

export default function EditProfilePage() {
  const { user, updateProfile } = useAuth();
  const [formData, setFormData] = useState({
    ddcName: "",
    ddcMobileNo: "",
    ddcEmailId: "",
    nodalOfficerDetails: {
      name: "",
      designation: "",
      mobileNo: "",
      emailId: "",
      dateOfAppointment: "",
    },
  });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setFormData({
        ddcName: user.ddcName || "",
        ddcMobileNo: user.ddcMobileNo || "",
        ddcEmailId: user.ddcEmailId || "",
        nodalOfficerDetails: {
          name: user?.nodalOfficerDetails?.name || "",
          designation: user?.nodalOfficerDetails?.designation || "",
          mobileNo: user?.nodalOfficerDetails?.mobileNo || "",
          emailId: user?.nodalOfficerDetails?.emailId || "",
          dateOfAppointment: user?.nodalOfficerDetails?.dateOfAppointment
            ? new Date(user.nodalOfficerDetails.dateOfAppointment).toISOString().slice(0, 10)
            : "",
        },
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // support nested nodalOfficerDetails fields with dot notation
    if (name.startsWith("nodalOfficerDetails.")) {
      const key = name.split(".")[1];
      setFormData({
        ...formData,
        nodalOfficerDetails: { ...formData.nodalOfficerDetails, [key]: value },
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      // convert date input (YYYY-MM-DD) to ISO if present
      const payload = { ...formData };
      if (payload.nodalOfficerDetails?.dateOfAppointment) {
        const d = new Date(payload.nodalOfficerDetails.dateOfAppointment);
        payload.nodalOfficerDetails.dateOfAppointment = d.toISOString();
      } else {
        // remove empty date to avoid sending empty string
        delete payload.nodalOfficerDetails.dateOfAppointment;
      }

      await updateProfile(payload);
      navigate("/my/profile");
    } catch (err) {
      // errors handled by updateProfile toast
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-2 bg-white border rounded-lg"
          >
            <FiArrowLeft /> Back
          </button>
          <h1 className="text-2xl font-bold">Edit Profile</h1>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
          <form onSubmit={handleSubmit} className="space-y-4">

            <div>
              <h3 className="text-md font-semibold mt-4 mb-2">DDC Details</h3>
              <label className="block text-sm font-medium text-gray-700 mb-1">DDC Name</label>
              <input
                name="ddcName"
                value={formData.ddcName}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />

              <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">DDC Mobile</label>
              <input
                name="ddcMobileNo"
                value={formData.ddcMobileNo}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />

              <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">DDC Email</label>
              <input
                name="ddcEmailId"
                value={formData.ddcEmailId}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            <div>
              <h3 className="text-md font-semibold mt-4 mb-2">Nodal Officer Details</h3>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              <input
                name="nodalOfficerDetails.name"
                value={formData.nodalOfficerDetails.name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />

              <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">Designation</label>
              <input
                name="nodalOfficerDetails.designation"
                value={formData.nodalOfficerDetails.designation}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />

              <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">Mobile No</label>
              <input
                name="nodalOfficerDetails.mobileNo"
                value={formData.nodalOfficerDetails.mobileNo}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />

              <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">Email</label>
              <input
                name="nodalOfficerDetails.emailId"
                value={formData.nodalOfficerDetails.emailId}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />

              <label className="block text-sm font-medium text-gray-700 mb-1 mt-3">Date Of Appointment</label>
              <input
                type="date"
                name="nodalOfficerDetails.dateOfAppointment"
                value={formData.nodalOfficerDetails.dateOfAppointment}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-white border rounded-lg"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg"
                disabled={saving}
              >
                <FiSave /> {saving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
